import { Injectable } from '@angular/core';
import { Account} from '@mitel/cloudlink-sdk';
import { AppUserClaimsService } from './app-user-claims.service';
import { IntegSharedCCService } from "./integ-shared-cc.service";

@Injectable({
	providedIn: 'root'
})

// this service will attempt to hide whatever ugliness is required to have this app x-launched from BOSS

export class XLaunchService {

	private context: string = undefined;
	private isXLaunched: boolean = false;
	private validConnectLogin: boolean = false;

	constructor( private appUserClaimsService: AppUserClaimsService,
		private cxService: IntegSharedCCService) 
	{
	}

	determineIfAppWasInvokedFromBoss( url: string ) : boolean
	{
		if ( url )
		{
			let theParams = url.split('?')[1];
			if ( theParams != null ) 
			{

				if ( theParams.indexOf('crossLaunch') >= 0 )
				{
					this.isXLaunched = true;
					sessionStorage.setItem('crossLaunch', 'true');
					// extract the context
					this.context = theParams.indexOf('context=') >= 0 ? theParams.split('context=')[1].split('&')[0] : '';
					sessionStorage.setItem('context', this.context);
				}
			}
			if ( this.isXLaunched == false )
			{
				if ( sessionStorage.getItem('crossLaunch') == 'true' )
					this.isXLaunched = true;
			}
		}
		return this.isXLaunched;
	}

	isXLaunchedFromBoss()
	{
		return this.isXLaunched;
	}

	getXLaunchContext()
	{
		return this.context;
	}

	// note: using the user claims or the user object is not accurate.
	// only the account source is accurate
	determineIfValidConnectUserLogin( account: Account )
	{
		let userClaims = this.appUserClaimsService.getClaims();
console.log("Current user claims", userClaims);
		if ( (account.source == "MICLOUD_CONNECT" || account.source == "MICLOUD_SKY") && 
				this.isXLaunched == true && 
				(userClaims.role == "ACCOUNT_ADMIN" || this.appUserClaimsService.isAssumedRole()) )
		{
			this.validConnectLogin = true;
			return true;
		}
		else
		{
			return false;
		}
	}

	isConnectSource( source )
	{
		return (source == "MICLOUD_CONNECT" || source == "MICLOUD_SKY");
	}

	isValidConnectLogin()
	{
		return this.validConnectLogin;
	}

	async getDefaultPageDependingOnContext( account: Account ): Promise<string[]>
	{
		if ( this.context && this.context == "m1settings" )
			return Promise.resolve(['accounts', account.accountId, 'integrations']);
		else if ( this.context && this.context == "m1manage" )
			return Promise.resolve(['accounts', account.accountId, 'users']);
		else if ( this.context && this.context == "cxsettings" )
		{
			let setupComplete = await this.cxService.isSetupComplete(account);
			if ( setupComplete )
				return Promise.resolve(['accounts', account.accountId, 'ccdashboard'])
			else
				return Promise.resolve(['accounts', account.accountId, 'integrations']);
		}
		return Promise.resolve(['accounts', account.accountId, 'integrations']);
	}

	async invokeAppropriateDefaultBehaviour( account: Account )
	{
		if ( this.context && this.context == "cxsettings" )
		{
			let setupComplete = await this.cxService.isSetupComplete(account);
			if ( setupComplete == false )
			{
				setTimeout( this.clickTheSetupButton, 5000 );
			}
		}
	}

	// can't tell when it is ready so we will test every 2 seconds
	setupButton = null;
	retries = 0;
	clickTheSetupButton()
	{
		this.setupButton = document.getElementById("integration-ccnext");
		if ( this.setupButton == null || this.setupButton == undefined  )
		{
			if ( this.retries < 10 ) // don't want to retry forever
			{
				setTimeout( this.clickTheSetupButton, 2000 );
				this.retries++;
			}
		}
		else
		{
			this.setupButton.click();
		}
	}

	/**
	 * For use when client has redirected from Shoretel BOSS/Connect product
	 * @returns 
	 */
	getDropMenuConfigConnect()
	{
		let dropMenu: any = {
			useLogoutMenu: false,   // set to false if you do not want the standard Logout menu
			clientMenus: [
			  {
				id: 'exit',
				displayLabelKey: "x-launch-config.exit-menu"
			  }
			]
		};
		return dropMenu;
	}

	handleMenuClick( menuItemId)
	{
		if ( menuItemId == "exit" )
		{
			sessionStorage.removeItem('crossLaunch');
			sessionStorage.removeItem('context');
			window.close();
		}
	}
}
